import React from 'react'

import DatesFields from '../FormFields/DatesFields'
import ErrorMessage from '../../../../../../components/Form/ErrorMessage'
import DailyRemainingImpressionsFields from './DailyRemainingImpressionsFields'

import { END_DATE, START_DATE } from '../../../../../ReusableFormFields/StartEndDateRangeFields/fields'

const NewCampaignImpressionsFields = ({ formik, remainingImpressions }) => {
  const { values } = formik
  const startDate = values[START_DATE]
  const endDate = values[END_DATE]
  const showBudgetSection = startDate && endDate

  if (remainingImpressions < 1) {
    return <ErrorMessage fontSize={14} error="Your remaining impressions are too low to create a campaign." />
  }

  return (
    <>
      <DatesFields formik={formik} />
      {showBudgetSection && (
        <DailyRemainingImpressionsFields
          formik={formik}
          remainingImpressions={remainingImpressions}
          startDate={startDate}
          endDate={endDate}
        />
      )}
    </>
  )
}

export default NewCampaignImpressionsFields
